<template>
  <div @click="handleClick" :key="datas.id" v-if="category" class="gallery_item">
    <template v-if="datas">
      <div class="gallery_item_content">
        <h4 class="title">
          <div class="title-text">
            <span class="serial-number mr-1">{{ index + 1 }}.</span>
            {{ datas.title }}
          </div>
        </h4>
        <div :class="['meta-date', { 'meta-date-min': hideDate }]" :style="{ visibility: !hideDate ? 'visible' : 'hidden' }">
          <span v-if="!hideDate">{{ datas.createdat }}</span>
          <span v-else>x</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: Boolean,
    },
    trending: {
      type: Boolean,
    },
    sports: { type: Boolean, default: false },
    datas: {
      type: Object,
    },
    counting: {
      type: Boolean,
    },
    countingtwo: {
      type: Boolean,
    },
    count: {
      type: Number,
    },
    index: {
      type: Number,
    },
    hideDate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    handleClick() {
      console.log(this.datas.link);
      // 先检查 link 存在且不为空字符串，再验证 URL 有效性
      if (this.datas.link && this.datas.link.trim() && this.isValidUrl(this.datas.link)) {
        window.open(this.datas.link, '_blank');
      } else {
        console.log('无效的链接地址:', this.datas.link);
      }
    }
  }

};
</script>

<style scoped>
.custom-img {
  width: 100px;
  height: auto;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.title-count-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  margin: 0;
  flex-grow: 1;
}

.count {
  margin-left: 10px; /* 可根据需要调整间距 */
}

.custom-hot-img {
  width: 80px;
  height: auto;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.custom-post-img {
  width: 80px;
  height: 70px;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.custom-sports-img {
  width: 100px;
  height: auto;
  object-fit: cover;
  object-position: center;
}

/* 容器 Flex 布局实现左右对齐 */
.gallery_item_content {
  display: flex;
  justify-content: space-between; /* 标题居左，日期居右 */
  align-items: center; /* 垂直居中对齐 */
  width: 100%; /* 确保容器占满宽度 */
}
.title {
  margin: 0;
  flex: 1; /* 标题占据剩余空间 */
}
.meta-date {
  white-space: nowrap; /* 防止日期换行 */
  text-align: right; /* 文本右对齐 */
  min-width: 120px;
  color: #999; /* 日期文字灰色 */
}

.meta-date-min {
  min-width: 10px;
}
.title-text{
  color: #333;
  font-size: 16px;
  /* 添加文本溢出省略号样式 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gallery_item .gallery_item_content .title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  height: 16px;
  line-height: 16px;
  transition: all 0.5s;
}
.gallery_item .gallery_item_content .title a {
  color: #333333;
}
</style>
